<template>
  <LevellingPageShell title="Levelling Framework" icon="mdi-view-grid-outline">
    <LevellingFramework hideTitle v-bind="$attrs" v-on="$listeners" />
  </LevellingPageShell>
</template>

<script>
// Levelling Framework ToC page — page head + centred content around the
// framework editor. The component's own title is hidden in favour of the page
// head. $attrs/$listeners forward props + emits to App.vue's router-view.
import LevellingPageShell from '@/components/levelling/LevellingPageShell.vue';
import LevellingFramework from '@/components/levelling/framework.vue';

export default {
  name: 'LevellingFrameworkPage',
  components: { LevellingPageShell, LevellingFramework },
  inheritAttrs: false,
};
</script>

<style lang="scss" scoped>
/* The framework sizes itself to the viewport (100vh - navbar); inside the
   centred page-shell wrap it should fill the wrap instead, so it scrolls
   internally rather than overflowing past the page head. Scoped to this
   wrapper — framework.vue's other (tabbed) use is unaffected. */
::v-deep .framework-container {
  height: 100% !important;
  padding: 0 !important;
}
</style>
